import { render } from "./DrugTest.vue?vue&type=template&id=04b66a0e&ts=true"
import script from "./DrugTest.vue?vue&type=script&lang=ts"
export * from "./DrugTest.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__